import { render, staticRenderFns } from "./ReturnLink.vue?vue&type=template&id=04754600&scoped=true&lang=pug"
var script = {}
import style0 from "./ReturnLink.vue?vue&type=style&index=0&id=04754600&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04754600",
  null
  
)

export default component.exports